import { useCallback, useState } from "react";
import { Switch } from "V2.0/common/switch";
import { showErrorToast } from "V2.0/utils";

export default AssistantCoachEnable;

function AssistantCoachEnable(props) {
  const { coachEnabled, onUpdateAssistant, locked } = props;

  const [isEnabled, setIsEnabled] = useState<boolean>(coachEnabled);

  const onToggleCoachEnabled = useCallback(async (value: boolean) => {
    const payload = {
      coachEnabled: value,
    };

    const lifecycleCbs = {
      init() {
        setIsEnabled(value);
      },
      success() {},
      error(e) {
        setIsEnabled(!value);
        showErrorToast(e, "Failed to update Assistant Coach");
      },
    };

    onUpdateAssistant(payload, lifecycleCbs);
  }, []);

  return (
    <div className="border rounded-lg flex gap-x-2 items-center p-4 px-8 rounded-t-lg bg-gray-50">
      <p className="text-base font-semibold">Assistant Coach</p>
      <Switch
        checked={isEnabled}
        disabled={locked}
        color="emerald"
        onChange={() => onToggleCoachEnabled(!isEnabled)}
      />
    </div>
  );
}
